import type { Dispatch, SetStateAction } from "react";

import FeedFooter from "@/components/FeedFooter";
import FeedVirtualizedList from "@/components/feed/FeedVirtualizedList";

export default function ClassicFeed({
  currentFeedDate,
  setRenderToggle,
}: {
  currentFeedDate: Date | null;
  setRenderToggle: Dispatch<SetStateAction<string>>;
}) {
  return (
    <>
      <FeedVirtualizedList
        hasGlobalAudioPlayer={false}
        currentFeedDate={currentFeedDate}
        setRenderToggle={setRenderToggle}
      />
      <FeedFooter />
    </>
  );
}
